import React from 'react'
import Modal from 'react-modal';
import ReactPlayer from 'react-player';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#root');
const PreviewMultimediaVideoModal = ({ modalVideoIsOpen, closeModal, previewFormData }) => {

    let subtitle;

  function afterOpenModal() {
    
    subtitle.style.color = "#f00";
  }

  return (
    <div>
    <Modal
      isOpen={modalVideoIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Previsualización Video"
    >
      <div>Previsualización Video</div>
      <form>
        <ReactPlayer url={previewFormData.url} width="100%" height="100%" controls loop className="react-player" />
      </form>
    </Modal>
  </div>
  )
}

export default PreviewMultimediaVideoModal